import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";
import { useAuthenticated } from "../authenticated/useAuthenticated";

export function useResourceSchedules(
  resourceId: string,
  office_ids: string[],
  division_ids: string[],
  weekDate: string,
  timeZone: string
) {
  const { api } = useTacticHooks();
  const {
    userContext: { deviceTz }
  } = useAuthenticated();
  const scheduleData = useQuery({
    queryKey: ["schedules", resourceId, weekDate, "day", timeZone],

    queryFn: async () => {
      const res = await api.client.tableOverview.getTableOverview({
        office_ids,
        division_ids,
        user_tz: deviceTz
      });

      return res.result;
    }
  });

  return scheduleData;
}
